import styled from 'styled-components'
import colors from '../../../tokens/colors'
import fonts from '../../../tokens/fonts'
import border from '../../../tokens/border'
import { defaultTheme } from '../../../theming/data/defaultTheme'
import { composeTheme } from '../../../utils/compose-theme'

export const MenuItem = styled.li.attrs((props) => composeTheme(props))`
  display: inline-flex;
  height: 100%;
  position: relative;

  svg {
    color: ${(props) => props.theme.navbar.menuItemIconColor};

    &:hover {
      color: ${(props) => props.theme.navbar.menuItemIconHoverColor};
      transition: color 0.6s;
    }
  }
`

export const Container = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`

export const Notification = styled.div.attrs((props) => composeTheme(props))`
  width: ${(props) => props.theme.navbar.menuItemNotificationSize};
  height: ${(props) => props.theme.navbar.menuItemNotificationSize};
  left: ${(props) => props.theme.navbar.menuItemNotificationLeft};
  top: ${(props) => props.theme.navbar.menuItemNotificationTop};
  border-radius: ${border.radius.radiusCircular};
  background-color: ${(props) =>
    props.theme.navbar.menuItemNotificationColor !==
    colors.brandColorPrimaryPure
      ? props.theme.navbar.menuItemNotificationColor
      : props.theme.brandColors.primaryPure};
  position: absolute;
`

export const Button = styled.button.attrs((props) => composeTheme(props))`
  -moz-osx-font-smoothing: inherit;
  -webkit-appearance: none;
  -webkit-font-smoothing: inherit;
  align-items: center;
  background: transparent;
  border: ${border.width.widthNone};
  color: ${(props) => props.theme.navbar.menuItemColor};
  cursor: pointer;
  display: flex;
  font-family: ${fonts.inter};
  font-size: ${(props) => props.theme.navbar.menuItemFontSize};
  font-style: normal;
  font-weight: ${(props) => props.theme.navbar.menuItemFontWeght};
  height: ${(props) => props.theme.navbar.menuItemHeight};
  letter-spacing: 0em;
  line-height: normal;
  margin: ${(props) => props.theme.navbar.menuItemMargin};
  overflow: visible;
  padding: ${(props) => props.theme.navbar.menuItemPadding};
  text-align: ${(props) => props.theme.navbar.menuItemTextAlign};
  text-decoration: none;
  width: ${(props) => props.theme.navbar.menuItemWidth};

  &:hover {
    color: ${(props) =>
      props.theme.navbar.menuItemHoverColor !== colors.brandColorPrimaryPure
        ? props.theme.navbar.menuItemHoverColor
        : props.theme.brandColors.primaryPure};
    background-color: ${(props) =>
      props.theme.navbar.menuItemHoverBackgroundColor};
    transition: color 0.6s;
    border-radius: ${(props) => props.theme.navbar.menuItemHoverBorderRadius};
  }

  &:focus {
    outline: 0;
    color: ${(props) =>
      props.theme.navbar.menuItemFocusColor !== colors.brandColorPrimaryPure
        ? props.theme.navbar.menuItemFocusColor
        : props.theme.brandColors.primaryPure};
  }
`

export const Text = styled.div.attrs((props) => composeTheme(props))`
  margin-right: ${(props) => props.theme.navbar.menuItemTextMarginRight};
  font-weight: ${(props) => props.theme.navbar.menuItemTextFontWeight};
`

export const Picture = styled.img.attrs((props) => composeTheme(props))`
  width: ${(props) => props.theme.navbar.menuItemPictureSize};
  height: ${(props) => props.theme.navbar.menuItemPictureSize};
  border-radius: ${border.radius.radiusCircular};
`

Button.defaultProps = defaultTheme
MenuItem.defaultProps = defaultTheme
Notification.defaultProps = defaultTheme
Picture.defaultProps = defaultTheme
Text.defaultProps = defaultTheme
